import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleCarry } from '@fortawesome/free-solid-svg-icons';
import PartDisplay from './PartDisplay';

const styles = theme => ({
    option: {
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    partNumberRow: {
        display: 'flex',
        alignItems: 'baseline',
        marginBottom: 0,
    },
    partNumber: {
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#333',
        marginRight: '4px',
    },
    revision: {
        fontSize: '14px',
        color: '#00acb5',
        fontWeight: 'bold',
    },
    description: {
        fontSize: '11px',
        color: '#555',
        lineHeight: '1.3',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        hyphens: 'auto',
        maxHeight: '40px',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },
});

/**
 * Custom option component for Material-UI Autocomplete
 * Displays part or family information in a readable format for dropdowns
 */
const PartAutocompleteOption = ({ option, classes, ...props }) => {
    if (!option) return null;

    // Handle family options
    if (option.family) {
        const { family } = option;
        return (
            <div className={classes.option} {...props}>
                <div className={classes.partNumberRow} style={{display: 'flex', alignItems: 'center'}}>
                    <span className={classes.partNumber}>{family.partFamilyId}</span>
                    <FontAwesomeIcon icon={faPeopleCarry} style={{ marginLeft: '3px', width: '16px', height: '16px' }} />
                </div>
                {family.description && (
                    <div className={classes.description}>
                        {family.description}
                    </div>
                )}
            </div>
        );
    }

    // Handle part options
    if (option.part) {
        const { part } = option;
        const { partId, revision, description } = part;

        return (
            <div className={classes.option} {...props}>
                <div className={classes.partNumberRow}>
                    <span className={classes.partNumber}>{partId}</span>
                    <span className={classes.revision}>rev</span>&nbsp;{revision}
                    {(part.currentlyPurchasing && option.currentlyPurchasing !== false) ? ' 🛒' : ''}
                </div>
                {description && (
                    <div className={classes.description}>
                        {description}
                    </div>
                )}
            </div>
        );
    }

    // Handle assembly options
    if (option.type === 'assembly') {
        return (
            <div className={classes.option} {...props}>
                <div className={classes.partNumberRow}>
                    <span className={classes.partNumber}>{option.partId}</span>
                    <span className={classes.revision}>rev</span>&nbsp;{option.revision}
                    {(option.currentlyPackaging ? ' 📦' : '') + (option.currentlySelling ? ' 🛒' : '')}
                </div>
                {option.description && (
                    <div className={classes.description}>
                        {option.description}
                    </div>
                )}
            </div>
        );
    }

    // Handle subassembly options
    if (option.type === 'subassembly') {
        return (
            <div className={classes.option} {...props}>
                <div className={classes.partNumberRow}>
                    <span className={classes.partNumber}>{option.partId}</span>
                    <span className={classes.revision}>rev</span>&nbsp;{option.revision}
                    {option.currentlyPackaging ? ' 📦' : ''}
                </div>
                {option.description && (
                    <div className={classes.description}>
                        {option.description}
                    </div>
                )}
            </div>
        );
    }

    // Fallback for other option types
    return (
        <div className={classes.option} {...props}>
            <div className={classes.partNumberRow}>
                <span className={classes.partNumber}>{option.title || 'Unknown'}</span>
            </div>
        </div>
    );
};

export default withStyles(styles)(PartAutocompleteOption);
